module.exports = __webpack_public_path__ + "img/满额有礼.7add3854.png";